import type { ReactNode } from 'react';

import { formatDateTime } from '../utils/formatting';

export function DetailRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex justify-between gap-4">
      <span className="text-sm font-medium text-gray-500">{label}</span>
      <span className="text-sm text-gray-900 text-right">{value}</span>
    </div>
  );
}

export function DateValue({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="text-gray-400">—</span>;
  return <>{formatDateTime(value)}</>;
}
